import React, { useEffect, useState } from "react";
import shape from "../../assets/images/shopping-arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faShoppingBag, faXmark } from "@fortawesome/free-solid-svg-icons";
import CartTotal from "./CartTotal";
import { useNavigate } from "react-router-dom";
import { api } from "../../Constant";
import axios from "axios";
import Popup from "../RegisterScreen/Popup";
import emptycart from "../../assets/images/empty-cart.png"

const ShoppingPage = ({ onCartUpdate }) => {
  const [cart, setCart] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const navigation = useNavigate();
  const [userid, setUserid] = useState("");
  const [cartUpdated, setCartUpdated] = useState(false);

  const getUserIdentifier = () => {
    const userId = localStorage.getItem("userId");
    const guestId = localStorage.getItem("guest_id");

    if (userId && userId !== guestId) {
      return { user_id: userId };
    } else {
      return { guest_id: guestId };
    }
  };
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    setUserid(userId);

    if (userId && userId !== "Guest") {

      axios.post(api + "cart_list", getUserIdentifier())
        .then(response => {
          if (response.data.success === "true") {
            const products = response.data.product || [];
            setCart(products);
          } else {
            console.log("No products found in cart");
          }
        })
        .catch(error => {
          console.log("Error:", error);
        });
    } else {
      // Guest cart from localStorage
      const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
      setCart(guestCart);
    }
  }, []);
  
  const removeCart = product_id => {
    if (userid && userid !== "Guest") {
      axios.post(api + "remove_cart", {
        product_id: product_id,
        ...getUserIdentifier()
      })
        .then(response => {
          if (response.data.success === "true") {
            setCart(prevCart => prevCart.filter(item => item.product_id !== product_id));
            setPopupMessage(response.data.message);
            setPopupVisible(true);
            setCartUpdated(!cartUpdated);
            onCartUpdate();
          } else {
            console.log("Failed to remove product from cart");
          }
        })
        .catch(error => {
          console.log("Error:", error);
        });
    } else {
      // Guest cart remove
      const updatedCart = cart.filter(item => item.product_id !== product_id);
      localStorage.setItem("guestCart", JSON.stringify(updatedCart));
      setCart(updatedCart);
      setPopupMessage("Item removed from guest cart.");
      setPopupVisible(true);
      setCartUpdated(!cartUpdated);
      onCartUpdate();
    }
  };
  useEffect(() => {
    const storedUserid = localStorage.getItem("userId");
    setUserid(storedUserid);
  }, []);

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const handleQuantityChange = (product_id, newQuantity) => {
    if (userid && userid !== "Guest") {
      axios.post(api + "cart_quantity_update", {
        ...getUserIdentifier(),
        product_id: product_id,
        quantity: newQuantity
      })
        .then(response => {
          if (response.data.success === "true") {
            setCart(prevCart =>
              prevCart.map(item =>
                item.product_id === product_id
                  ? {
                    ...item,
                    selected_quantity: newQuantity,
                    total:
                      newQuantity *
                      (item.discount_price > 0 ? item.discount_price : item.price),
                  }
                  : item
              )
            );
            setCartUpdated(!cartUpdated);
            onCartUpdate();
          }
        })
        .catch(error => {
          console.log("Error:", error);
        });
    } else {
      // Guest quantity update
      const updatedCart = cart.map(item =>
        item.product_id === product_id
          ? {
            ...item,
            selected_quantity: newQuantity,
            total: item.discount_price * newQuantity
          }
          : item
      );
      localStorage.setItem("guestCart", JSON.stringify(updatedCart));
      setCart(updatedCart);
      setCartUpdated(!cartUpdated);
      onCartUpdate();
    }
  };
  const continueshoping = () => {
    navigation("/");
  };
  const handlePaymentSuccess = () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      axios
        .post(api + "cart_list", { user_id: userId })
        .then(response => {
          if (response.data.success === "true") {
            const products = response.data.product || [];
            setCart(products);
          } else {
            console.log("No products found in cart");
          }
        })
        .catch(error => {
          console.log("Error:", error);
        });
    }
  };
  const navigatehome = () => {
    navigation("/")
  }
  return (
    <div className="shopping-cartbg pt-40 pb-40">
      <div className="container">
        {cart.length === 0
          ? <div className="row cart-empty-padding">
            <div className="col-lg-12 cart-empty">
              <img src={emptycart} alt='empty Cart' />
              <h2>Your Cart is <span>Empty !</span></h2>
              <p>Looks like yoy haven’t added anything <br /> to your cart yet</p>
              <button onClick={navigatehome}>Countinue Shoping</button>
            </div>
          </div>
          : <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-lg-12 shopping-tit-container">
                  <h1>SHOPPING CART</h1>
                  <img src={shape} alt="shape" />
                  <h3>BILLING ADDRESS</h3>
                  <img src={shape} alt="shape" />
                  <h3>PAYMENT DETAIL</h3>
                </div>
              </div>
              <div className="row main-producttable">
                <table className="product-table table-responsive">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th />
                      <th>Price</th>
                      <th>Total</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {cart.map(item => {
                      return (
                        <tr key={item.product_id}>
                          <td>
                            <img
                              src={item.product_image}
                              alt="pro-img"
                              style={{ width: "100%" }}
                            />
                          </td>
                          <td>
                            <h6>
                              {item.name}
                            </h6>
                            <p>
                              Size : {item.selected_size_name}
                            </p>
                            <select
                              id="quantity"
                              className="quntity"
                              value={item.selected_quantity}
                              onChange={e =>
                                handleQuantityChange(
                                  item.product_id,
                                  e.target.value
                                )}
                            >
                              {[
                                ...Array(parseInt(item.max_quantity)).keys()
                              ].map(num =>
                                <option key={num + 1} value={num + 1}>
                                  {num + 1}
                                </option>
                              )}
                            </select>
                          </td>
                          <td>
                            {(() => {
                              const hasDiscount = Number(item.discount_price) > 0;
                              return (
                                <>
                                  ₹ {hasDiscount ? item.discount_price : item.price}
                                  {hasDiscount && (
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        marginLeft: "10px",
                                        color: "gray",
                                        fontSize: "18px",
                                      }}
                                    >
                                      ₹ {item.price}
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </td>
                          <td>
                            ₹ {item.total}
                          </td>
                          <td>
                            <div
                              className="product-cancel"
                              onClick={() => removeCart(item.product_id)}
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="product-bottom-cont"
                    onClick={continueshoping}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <h5>Continue Shopping</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 shoping-cartscroll">
              <CartTotal
                CartTotal="CONTINUE"
                cartUpdated={cart}
                onCartUpdate={onCartUpdate}
              />
            </div>
          </div>}
        {popupVisible &&
          <Popup
            message={popupMessage}
            title="Notice"
            type="success"
            onClose={handleClosePopup}
          />}
      </div>
    </div>
  );
};

export default ShoppingPage;
